import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseRut',
})
export class ParseRutPipe implements PipeTransform {

  transform(rut: string | undefined): string | undefined {
    if (rut) {
      let div1 = rut.slice(0, 2);
      let div2 = rut.slice(2, 5);
      let div3 = rut.slice(5, 8);
      let div4 = rut.slice(8, 9);

      if (rut.length === 8) {
        div1 = rut.slice(0, 1);
        div2 = rut.slice(1, 4);
        div3 = rut.slice(4, 7);
        div4 = rut.slice(7, 8);
      }

      return `${div1}.${div2}.${div3}-${div4}`;
    }
    return rut;
  }

}
